import { SortableList } from "@circle-react/components/shared/uikit/SortableList";
import { useLgScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";

import { AddLinkButton } from "./AddLinkButton";
import type { SidebarLink } from "./LinkItem";
import { LinkItem } from "./LinkItem";
import { LinkItemDragOverlay } from "./LinkItemDragOverlay";

export interface LinksListProps {
  isAdmin: boolean;
  links: SidebarLink[];
  onSort: (reorderedItems: SidebarLink[]) => void;
}

export const LinksList = ({ isAdmin, links, onSort }: LinksListProps) => {
  const isLargeScreen = useLgScreenMediaQuery();
  const shouldDisableSort = !isAdmin || !isLargeScreen;

  return (
    <SortableList
      items={links}
      onSort={onSort}
      distance={5}
      lockedVerticalAxis
      shouldUseKeyboardSensor={false}
    >
      <SortableList.List className="flex flex-col gap-y-1" gap={0}>
        {links.map(link => (
          <SortableList.Item
            disabled={shouldDisableSort}
            item={link}
            key={link.id}
            tabIndex={-1}
          >
            <LinkItem isAdmin={isAdmin} link={link} />
          </SortableList.Item>
        ))}
        {isAdmin && <AddLinkButton />}
      </SortableList.List>
      <SortableList.DragOverlay adjustScale={false}>
        <LinkItemDragOverlay />
      </SortableList.DragOverlay>
    </SortableList>
  );
};
